import axiosIns from '@/libs/axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAzimutAccounts() {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('getAzimutAccounts')
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getAzimutReportData(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('getAzimutReportData', queryParams)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    downloadAzimutTradesXlsx(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('downloadAzimutTradesXlsx', queryParams, { responseType: 'blob' })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    downloadAzimutSettlementXlsx(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('downloadAzimutSettlementXlsx', queryParams, { responseType: 'blob' })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
